import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import logo from '../../assets/logo.png';

const Header = ({ user, onToggleSidebar, sidebarOpen }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      toast.error('Logout gagal. Silakan coba lagi.');
    }
  };

  const getRoleDisplayName = (role) => {
    switch (role) {
      case 'admin':
        return 'Administrator';
      case 'pengguna':
        return 'Pengguna';
      case 'peninjau':
        return 'Peninjau';
      default:
        return role;
    }
  };

// Detect klik di luar dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  return (
    <header className="app-header d-flex">
      <div className="container-fluid py-3 fixed-top bg-primary">
        <div className="row align-items-center">
          <div className="col-auto">
            <button
              className="btn btn-link text-white d-md-none"
              onClick={onToggleSidebar}
            >
              <i className={`fas fa-${sidebarOpen ? 'times' : 'bars'}`}></i>
            </button>
          </div>
          
          <div className="col">
            <div className="logo-container">
              <img src={logo} alt="SadarTalaud Logo" className="logo" />
              <div className='dinas-name'>
                <h3>DINAS PERUMAHAN DAN KAWASAN PEMUKIMAN</h3>
                <h5>KABUPATEN KEPULAUAN TALAUD</h5>
              </div>
            </div>
          </div>
          
          <div className="col-auto on-non-mobile-toggle">
            <div className="d-flex align-items-center" ref={dropdownRef}>
              <div className="dropdown" >
                <button
                  type="button" 
                  className="btn btn-link text-white dropdown-toggle"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <div className='user-icon'>
                    <i className="fas fa-user-circle me-2"></i>
                    {/* {user?.full_name || 'User'} */}
                  </div>
                </button>
                
                {showUserMenu && (
                  <div className="dropdown-menu dropdown-menu-end show"
                    data-bs-display='static'
                    data-bs-offset='0,100'  
                  >
                    <div className="dropdown-header">
                      <strong>{user?.full_name}</strong>
                      <br />
                      <small className="text-muted">
                        {getRoleDisplayName(user?.role)}
                      </small>
                    </div>
                    <div className="dropdown-divider"></div>
                    <Link className="dropdown-item" to="/profile">
                      <i className="fas fa-user me-2"></i>
                      Profile
                    </Link>
                    <button
                      className="dropdown-item text-danger"
                      onClick={handleLogout}
                    >
                      <i className="fas fa-sign-out-alt me-2"></i>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 